export const CONVERSATION_AI_RESPONSE_WINDOWS = Object.freeze([
  'always',
  'business_hours',
  'outside_business_hours',
]);

export const CONVERSATION_AI_AUTO_RESOLVE_MODES = Object.freeze([
  'evaluated',
  'legacy',
  'disabled',
]);
export const MIN_INACTIVITY_MINUTES = 5;
export const MAX_INACTIVITY_MINUTES = 24 * 60;

export const buildBasicSettingsPatch = ({
  name = '',
  description = '',
  productName = '',
  featureFaq = false,
  featureMemory = false,
  featureCitation = false,
  featureContactAttributes = false,
}) => ({
  name: String(name),
  description: String(description),
  config: {
    product_name: String(productName),
    feature_faq: Boolean(featureFaq),
    feature_memory: Boolean(featureMemory),
    feature_citation: Boolean(featureCitation),
    feature_contact_attributes: Boolean(featureContactAttributes),
  },
});

export const buildSystemSettingsPatch = ({
  handoffMessage = '',
  resolutionMessage = '',
  responseGuidelines = '',
  guardrails = '',
  autoResolveMode = 'evaluated',
  inactivityThresholdMinutes = 60,
  sendInactivityResolutionMessage = true,
}) => {
  if (!CONVERSATION_AI_AUTO_RESOLVE_MODES.includes(autoResolveMode)) {
    throw new Error('Unsupported Conversation AI inactivity mode');
  }
  const threshold = Number(inactivityThresholdMinutes);
  if (
    !Number.isInteger(threshold) ||
    threshold < MIN_INACTIVITY_MINUTES ||
    threshold > MAX_INACTIVITY_MINUTES
  ) {
    throw new Error('Conversation AI inactivity threshold is out of range');
  }
  return {
    response_guidelines: String(responseGuidelines)
      .split('\n')
      .map(line => line.trim())
      .filter(Boolean),
    guardrails: String(guardrails)
      .split('\n')
      .map(line => line.trim())
      .filter(Boolean),
    config: {
      handoff_message: String(handoffMessage),
      resolution_message: String(resolutionMessage),

      auto_resolve_mode: autoResolveMode,
      auto_resolve_after: threshold,
      send_inactivity_resolution_message: Boolean(
        sendInactivityResolutionMessage
      ),
    },
  };
};

export const buildAudienceSettingsPatch = audience => ({
  config: {
    audience: audience ?? null,
  },
});

export const buildScheduleSettingsPatch = responseWindow => {
  if (!CONVERSATION_AI_RESPONSE_WINDOWS.includes(responseWindow)) {
    throw new Error('Unsupported Conversation AI response window');
  }
  return {
    config: {
      response_window: responseWindow,
    },
  };
};
